const translate = (components, func, isObj = true) => {
  const componentsReturn = [];
  components.forEach((obj) => {
    if (isObj ? obj instanceof Object : typeof obj === 'string') {
      componentsReturn.push(obj);
    } else {
      const list = func(obj);
      if (typeof list === 'object') {
        componentsReturn.push(...list);
      } else {
        componentsReturn.push(list);
      }
    }
  });
  return componentsReturn;
};

export default translate;
